<template>
  <div>
    <!-- Modal. Contiene el card del listado de traspasos. -->
    <b-modal
      id="traspasosModal"
      title="Traspasos"
      v-model="show"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      dialog-class="x-modal-lg"
    >
      <template #modal-title>
        <!-- Tags -->
        <div class="my-2">
          <b-badge variant="success" v-if="mes">Mes: {{ getMonthById(mes).value }}</b-badge>
        </div>
      </template>

      <!-- Body -->
      <template>
        <div class="card card-header-actions">
          <div class="card-header">
            Listado de traspasos actuales
            <!-- Nuevo registro. Abre sidebar. -->
            <b-button v-b-toggle.traspasosFormSidebar size="sm" variant="success">Crear</b-button>
          </div>
          <div class="card-body p-1"><traspasos-list :mes="mes"></traspasos-list></div>
        </div>

        <traspasos-sidebar :mes="mes"></traspasos-sidebar>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TraspasosList from '@/components/Traspasos/TraspasosList'
import TraspasosSidebar from '@/components/Traspasos/TraspasosSidebar'

export default {
  name: 'traspasosModal',

  components: {
    TraspasosList,
    TraspasosSidebar
  },

  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },

    mes: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      show: this.value,

      showImportForm: false
    }
  },

  computed: mapGetters('UIModule', ['getMonthById']),

  watch: {
    value (newValue) {
      this.show = newValue
    },

    show (newValue) {
      this.$emit('input', newValue)
    }
  },

  methods: {
    onShowImportForm (value) {
      this.showImportForm = value
    }
  }
}
</script>
